
import { graphql, useStaticQuery } from 'gatsby'
import PropTypes from 'prop-types'
import * as React from 'react'
import { Helmet } from 'react-helmet'
import stripTags from './utils/stripTags'

function SEO({ description, lang, meta, title, datePublished, dateModified, isArticle, image }) {
	const { site } = useStaticQuery(
		graphql`
			query {
				site {
					siteMetadata {
						title
						description
						author
					}
				}
			}
		`
	)

	const metaDescription = stripTags(description || site.siteMetadata.description)
	const defaultTitle = site.siteMetadata?.title

	return (
		<Helmet
			htmlAttributes={{
				lang,
			}}
			title={title}
			titleTemplate={defaultTitle ? `%s | ${defaultTitle}` : null}
			meta={[
				{
					name: `viewport`,
					content: `width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no`,
				},
				{
					name: `description`,
					content: metaDescription,
				},
				{
					property: `og:title`,
					content: title,
				},
				{
					property: `og:description`,
					content: metaDescription,
				},
				{
					property: `og:type`,
					content: isArticle ? `article` : `website`,
				},
				{
					name: `twitter:card`,
					content: `summary`,
				},
				{
					name: `twitter:creator`,
					content: site.siteMetadata?.author || ``,
				},
				{
					name: `twitter:title`,
					content: title,
				},
				{
					property: `og:image`,

					content: image || `/share.jpg`,
				},
				{
					name: `twitter:description`,
					content: metaDescription,
				},
				...(datePublished && isArticle
				? [
						{
							property: `article:published_time`,
							content: datePublished,
						},
				  ]
				: []),
			...(dateModified && isArticle
				? [
						{
							property: `article:modified_time`,
							content: dateModified,
						},
				  ]
				: []),
		].concat(meta)}
		>
			{isArticle && datePublished && (
				<script type='application/ld+json'>
					{JSON.stringify({
						'@context': 'https://schema.org',
						'@type': 'Article',
						headline: title,
						description: metaDescription,
						image: image || '/share.jpg',
						datePublished: datePublished,
						...(dateModified && { dateModified: dateModified }),
						author: {
							'@type': 'Organization',
							name: 'MOTIV Group',
						},
						publisher: {
							'@type': 'Organization',
							name: 'MOTIV Group',
							logo: {
								'@type': 'ImageObject',
								url: 'https://motivgroup.com.au/share.jpg',
							},
						},
					})}
				</script>
			)}
		</Helmet>
	)
}

SEO.defaultProps = {
	lang: `en`,
	meta: [],
	description: ``,
	datePublished: null,
	dateModified: null,
	isArticle: false,
	image: null,
}

SEO.propTypes = {
	description: PropTypes.string,
	lang: PropTypes.string,
	meta: PropTypes.arrayOf(PropTypes.object),
	title: PropTypes.string.isRequired,
	datePublished: PropTypes.string,
	dateModified: PropTypes.string,
	isArticle: PropTypes.bool,
	image: PropTypes.string,
}

export default SEO
